let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let React = require("ES/lib/react");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let ConfirmModal = require("../../widgets/ConfirmModal");
let SlideOpenDown = require("../../widgets/SlideOpenDown");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let HorizontalFieldSpot = require("react-loose-forms.bootstrap3/layouts/HorizontalFieldSpot");
let EventFormUnsavedChangeMixin = require("./EventFormUnsavedChangeMixin");

let DaForm = dd.createClass({
	mixins: [FormMixin, EventFormUnsavedChangeMixin],
	getInitialValuesSourceVersion(props){
		return esUtils.getEventVersionIdentifier(props.event);
	},
	getInitialValues(props){
		let event = props.event;
		if(!event){
			return null;
		}
		return this.props.eventToInitialValues(event);
	},
	buildSchema(){
		let data = this.state.data || {};
		let schema = this.props.buildSchema.call(null, this.props, data);

		if(this.props.read_only){
			return _.mapValues(schema, function(field){
				return _.assign(field, {read_only: true});
			});
		}
		return schema;
	},
	__onFormChanged(field_path, field_value) {
		let data = this.state.data || {};
		if (_.isFunction(this.props.onFormChanged)) {
			this.props.onFormChanged(field_path, field_value, data, this.Form_onChange);
		}
	},
	render(){
		let has_fields = !_.isEmpty(this.Form_buildSchema());
		let changes_made = this.Form_areChangesMade();
		let {form_section_name, renderFields, renderButtons} = this.props;

		return dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
			has_fields && !esUtils.isBlank(form_section_name)
				? dd.h4({className: "section-head"}, form_section_name)
				: null,
			renderFields
				? renderFields.apply(this)
				: ezHorizontalFields(this),
			renderButtons
				? renderButtons.apply(this)
				: SlideOpenDown({open: changes_made},
						HorizontalFieldSpot(null,
							FormButtons({onDiscard: this.__discardChanges})
						)
					),
			this.props.children//potentially the ConfirmModal will be rendered here
		);
	}
});

module.exports = function(config){
	_.each([
		"buildSchema",
		"eventToInitialValues",
		"writeInputDataToEvent"
	], function(fn_name){
		if(!_.isFunction(config[fn_name])){
			throw new Error("cannot createStandardEventForm, missing: " + fn_name);
		}
	});
	let renderFields = _.isFunction(config.renderFields) ? config.renderFields : undefined;
	let renderButtons = _.isFunction(config.renderButtons) ? config.renderButtons : undefined;
	let onFormChanged = _.isFunction(config.onFormChanged) ? config.onFormChanged : undefined;
	let confirmMessageBeforeSave = _.isFunction(config.confirmMessageBeforeSave) ? config.confirmMessageBeforeSave : undefined;
	return dd.createClass({
		propTypes: {
			event: React.PropTypes.object.isRequired
		},
		getInitialState(){
			return {confirm_data: null};
		},
		__onSubmit(data){
			let old_event = this.props.event;
			if(!old_event){
				return;
			}
			let new_event = _.cloneDeep(old_event);
			config.writeInputDataToEvent(data, new_event);//this mutates new_event

			let confirm_msg = confirmMessageBeforeSave ? confirmMessageBeforeSave(old_event, new_event) : undefined;
			if(confirm_msg){
				this.setState({confirm_data: {message: confirm_msg, saveIt(){
					radio("save_Event").broadcast(new_event);
				}}});
			}else{
				radio("save_Event").broadcast(new_event);
			}
		},
		__confirmYes: esUtils.wrapPreventDefault(function(){
			let {confirm_data} = this.state;
			confirm_data.saveIt();
			this.setState({confirm_data: null});
		}),
		__closeConfirm: esUtils.wrapPreventDefault(function(){
			this.setState({confirm_data: null});
		}),
		render(){
			let {confirm_data} = this.state;
			return DaForm(_.assign({}, this.props, {
					renderFields,
					renderButtons,
					onFormChanged,
					onSubmit: this.__onSubmit,
					buildSchema: config.buildSchema,
					eventToInitialValues: config.eventToInitialValues
				}),
				confirm_data
					? ConfirmModal({message: confirm_data.message, onYes: this.__confirmYes, onClose: this.__closeConfirm})
					: null
			);
		}
	});
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/createStandardEventForm.js